export default "__VITE_ASSET__B$81BB$C__"